import { useQuery } from '@tanstack/react-query';
import AssetTypeService from '~/modules/services/asset-type-service';

export function useAssetTypes() {
	const {
		data: assetTypes = [],
		isLoading,
		isError,
		error,
		dataUpdatedAt: lastLoadedAt,
		refetch
	} = useQuery({
		queryKey: ['assetTypes'],
		queryFn: () => AssetTypeService.getAllAssetTypes(),
		staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
		refetchOnMount: false,
		refetchOnReconnect: false,
		refetchOnWindowFocus: false
	});

	return {
		assetTypes,
		isLoading,
		isError,
		error,
		isLoaded: !!assetTypes.length,
		lastLoadedAt: lastLoadedAt ? new Date(lastLoadedAt) : null,
		refetch
	};
}